<template>
  <div class="login">
    <LoginAdmnin />
  </div>
</template>

<script>
// @ is an alias to /src
import LoginAdmnin from '@/components/LoginAdmin.vue'

export default {
  name: 'Login',
  components: {
    LoginAdmnin
  }
}
</script>